export default "__VITE_ASSET__d7f94503__"